var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.orderBy==_vm.field)?_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas",class:[_vm.direction==='asc' ? 'fa-sort-up' : 'fa-sort-down']})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }